import React from "react";

const STEPS = [
  {
    number: "01",
    title: "Upload",
    description:
      "Drag-and-drop your raw nanopore signal files and reference sequences into the cloud.",
  },
  {
    number: "02",
    title: "Basecall",
    description:
      "Run GPU-accelerated basecalling with your choice of exclusive or standard models.",
  },
  {
    number: "03",
    title: "Analyze",
    description:
      "Cluster variants, detect modifications, run QC — all from the same dashboard.",
  },
  {
    number: "04",
    title: "Share",
    description:
      "Export results, share experiments with collaborators, and visualize data in real time.",
  },
];

const WorkflowStrip = () => {
  return (
    <section className="workflow-section">
      <div className="container">
        <div className="features-header">
          <h2 className="features-title">How it works</h2>
          <p className="features-subtitle">
            From raw signal to publication-ready results in four steps.
          </p>
        </div>

        <div className="workflow-grid">
          {STEPS.map((step, i) => (
            <div key={i} className="workflow-step">
              <span className="step-number">{step.number}</span>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-desc">{step.description}</p>
              {i < STEPS.length - 1 && <div className="step-connector" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowStrip;
